import React from "react";
import {
  Container,
  Stack,
  Flex,
  Box,
  Heading,
  Text,
  Image,
} from '@chakra-ui/react';
import Picture from '../../assets/image/picture.jpeg'

const Contact = () => {
  return (
    <Container backgroundColor={'#f7f8fd'} maxW={'9xl'} margintop={24}>
    <Container maxW={'7xl'}>
    <Heading
      textAlign={'center'}
      lineHeight={1.1}
      fontWeight={500}
      fontSize={{ base: '3xl', sm: '4xl', lg: '6xl' }}>
      <Text as={'span'} color={'#2347f9'}>
        Contact
      </Text>
    </Heading>
    <Flex
      flex={1}
      justify={'center'}
      align={'center'}
      position={'relative'}
      w={'full'}
      marginBottom={12}
      >
      <Box
        position={'relative'}
        height={'420px'}
        rounded={'2xl'}
        boxShadow={'2xl'}
        width={'full'}
        overflow={'hidden'}
        marginTop={24}

        >
         
        <Image
          alt={'Hero Image'}
          fit={'cover'}
          align={'center'}
          w={'100%'}
          h={420}
          src={
            Picture
          }
        />
      </Box>
    </Flex>
    <Stack
       align={'center'}
       spacing={{ base: 8, md: 10 }}
       py={{ base: 10, md: 18 }}
       direction={{ base: 'column', md: 'row' }}>
       <Stack flex={1} spacing={{ base: 5, md: 10 }}>
         <Heading
           lineHeight={1.1}
           fontWeight={600}
          //  fontSize={{ base: '3xl', sm: '4xl', lg: '6xl' }}
        >
          <Text as={'span'} color={'#2347f9'}>
            Les't connected and Discution
          </Text>
        </Heading>
         <Text fontWeight={500} color={'black'}>
          I would be interested if you want to talk and discuss about the Frontend project
         </Text>

          <Container maxW={'4xl'}>
            <Text fontWeight={500}>Email: dickyardiar1@gmail.com</Text>
            <Text fontWeight={500}>Phone: +62 851-5621-3384 </Text>
            <Text fontWeight={500}>Addres: Kebakkramat, Karanganyar, Jawa Tengah</Text>
          </Container>
       </Stack>
       
     </Stack>
    </Container>
   </Container>
  )
}

export default Contact